import React from "react";
import WarningIcon from "assets/images/warning.svg";
import SuccessIcon from "assets/images/verified-sign.svg";
import Modal from "components/common/Modal/Modal";
import { IPaiyaErrorProps } from "./PaiyaError.interface";

const PaiyaError = (props: IPaiyaErrorProps) => {
  const {
    giftCsvError,
    storeCsvError,
    movStatusError,
    closeModal,
    showModal
  } = props;

  const isSuccess = !(giftCsvError || storeCsvError);

  let modalHeading = "";
  if (!isSuccess) {
    modalHeading = "Errors Occured";
  }

  const ModalContent = (props: { title: string, error: string | { errors: string[] } }) => {
    const { title, error } = props;
    return (
      <div className="py-3">
        <section className="upload-error">
          <img src={WarningIcon} />
          <div className="title">{title}</div>
        </section>
        <div className="desc">
          Error Message:
          {typeof error === "string" ?
            <div className="format-msg-style">{error}</div>
            :
            (error)
              .errors
              .map((e) => <div className="format-msg-style">{e}</div>)
          }
        </div>
      </div>
    )
  }


  return (
    <Modal
      modalHeading={modalHeading}
      showModal={showModal}
      closeModalHandler={closeModal}
      isSuccess={!!(giftCsvError && storeCsvError)}
      modalBodyClass="batch-modal"
      showProgressString={false}
    >

      {giftCsvError ? (
        <ModalContent
          title="Gift(s) CSV Upload failed"
          error={giftCsvError as any}
        />
      ) : null}
      {storeCsvError ? (
        <ModalContent
          title="Store(s) CSV Upload failed"
          error={storeCsvError as any}
        />
      ) : null}

      {movStatusError ? (
        <ModalContent
          title="Mov Update failed"
          error={movStatusError as any}
        />
      ) : null}

      {isSuccess ? (
        <div className="py-3">
          <img src={SuccessIcon} />
          Data uploaded successfully.
        </div>
      ) : null}

    </Modal>
  )

};

export default PaiyaError;
